<template>
  <div class="font-sans bg-[#f6f4f1] text-[#1f2937] min-h-screen flex flex-col">
    <AppHeader />

    <div class="max-w-7xl mx-auto px-4 py-8 w-full">
      <h1 class="text-3xl font-semibold mb-8">Publicar um Projeto</h1>

      <div class="bg-white shadow rounded-2xl p-6 mb-8">
        <div class="grid gap-6">

          <input v-model="form.title" type="text" placeholder="Título do projeto" class="input-gold" />

          <textarea v-model="form.description" rows="6" placeholder="Descrição detalhada do projeto"
            class="input-gold"></textarea>

          <!-- Select para escolher categorias (retorna o objeto categoria) -->
          <!--<select v-model="selectedCategory" @change="addCategory" class="input-gold">
            <option value="" disabled>Selecione a categoria</option>
            <option v-for="cat in categories" :key="cat.id" :value="cat">
              {{ cat.description }}
            </option>
          </select>-->

          <select v-model="selectedCategory" @change="addCategory" class="input-gold mt-1">
                        <option value="" disabled>Selecione as categorias</option>
                        <option v-for="cat in categories" :key="cat.id" :value="cat.id">
                            {{ cat.description }}
                        </option>
                    </select>
          <!-- Chips das categorias selecionadas -->
          <div class="flex flex-wrap gap-2 mt-2">
            <div v-for="(cat, index) in form.categories" :key="cat.id || index"
              class="bg-[#1a1a1a] text-white px-3 py-1 rounded-full flex items-center gap-2">
              <span class="text-sm">{{ cat.description }}</span>
              <button @click="removeCategory(index)" class="text-red-400 text-sm">×</button>
            </div>
          </div>
          

          <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div class="flex flex-col">
              <label class="mb-1 font-medium">Urgência</label>
              <select v-model="form.urgency_level" class="input-gold">
                <option value="low">Baixa</option>
                <option value="medium">Média</option>
                <option value="high">Alta</option>
              </select>
            </div>

            <!--<div class="flex flex-col">
              <label class="mb-1 font-medium">Orçamento (R$)</label>
              <input v-model="form.budget" type="number" step="0.01" class="input-gold" />
            </div>-->

            <div class="flex flex-col">
              <label class="mb-1 font-medium">Prazo final</label>
              <input v-model="form.deadline" type="date" class="input-gold" />
            </div>
          </div>

          <div>
            <label class="font-medium mb-2 block">Anexos (PDF, DOC, DOCX, PNG, JPG, JPEG, WEBP)</label>
            <input @change="handleFiles" type="file" multiple accept=".pdf,.doc,.docx,.png,.jpg,.jpeg,.webp"
              class="input-gold" />

            <div v-if="files.length" class="mt-4 space-y-2">
              <div v-for="(file, index) in files" :key="file.name + index"
                class="flex justify-between items-center bg-gray-100 p-3 rounded-xl">
                <div class="flex items-center gap-3">
                  <span class="text-sm">{{ file.name }}</span>
                  <span class="text-xs text-gray-500">({{ formatBytes(file.size) }})</span>
                </div>
                <button @click="removeFile(index)" class="text-red-600 text-sm">Remover</button>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="flex justify-end gap-4 mt-6">
        <button @click="resetForm" class="px-6 py-3 rounded-xl border border-gray-400">Limpar</button>
        <button @click="confirmSubmission" class="px-6 py-3 rounded-xl bg-[#1a1a1a] text-white">Publicar
          Projeto</button>
      </div>
    </div>

    <AppFooter />
  </div>
</template>

<script setup>
import { ref, onMounted, getCurrentInstance } from 'vue'
import api from '@/services/api';
import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'
import { useRouter, useRoute } from "vue-router";

const { proxy } = getCurrentInstance()

const router = useRouter();
const form = ref({
  title: '',
  description: '',
  category_id: '',
  urgency_level: 'low',
  budget: '',
  deadline: '',
  categories: []
})

const categories = ref([])
const selectedCategory = ref('')
const files = ref([])

onMounted(() => {
  getCategories()
})

const addCategory = () => {
  if (!selectedCategory.value) return;

  const item = categories.value.find(s => s.id === selectedCategory.value);

  if (item && !form.value.categories.some(s => s.id === item.id)) {

    form.value.categories.push({
      id: item.id,
      description: item.description
    });

    categories.value = categories.value.filter(c => c.id !== item.id);
  }

  selectedCategory.value = "";
};


const removeCategory = (index) => {
  form.value.categories.splice(index, 1)
}

const handleFiles = (event) => {
  const incoming = Array.from(event.target.files || [])
  const allowed = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'image/png', 'image/jpeg', 'image/webp']
  const filtered = incoming.filter(f => allowed.includes(f.type) || /\.pdf|\.docx?|\.png|\.jpe?g|\.webp$/i.test(f.name))
  files.value = files.value.concat(filtered)
}

const removeFile = (index) => {
  files.value.splice(index, 1)
}

const resetForm = () => {
  form.value = {
    title: '',
    description: '',
    category_id: '',
    urgency_level: 'low',
    budget: '',
    deadline: '',
    categories: []
  }
  files.value = []
  selectedCategory.value = ''
}

const sendProject = async () => {
  try {
    if (!form.value.title.trim()) {
      proxy.$swal.fire({ icon: 'warning', title: 'Título obrigatório' })
      return
    }
    if (!form.value.description.trim()) {
      proxy.$swal.fire({ icon: 'warning', title: 'Descrição obrigatória' })
      return
    }
    if (!form.value.deadline.trim()) {
      proxy.$swal.fire({ icon: 'warning', title: 'Prazo final obrigatório' })
      return
    }

    const payload = new FormData()
    payload.append('title', form.value.title)
    payload.append('description', form.value.description)
    payload.append('category_id', form.value.category_id || '')
    payload.append('urgency_level', form.value.urgency_level)
    payload.append('budget', form.value.budget || '')
    payload.append('deadline', form.value.deadline || '')

    /*const categoriesString = form.value.categories
      .map(c => c.description)
      .join(', ')
    payload.append('categories', categoriesString)*/
    payload.append("categories", JSON.stringify(form.value.categories));

    files.value.forEach((file) => {
      payload.append('attachments[]', file)
    })

    await api.post('/projects', payload, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })

    proxy.$swal.fire({ icon: 'success', title: 'Projeto publicado com sucesso' })
    resetForm()
    router.push('/projetos');

  } catch (error) {
    console.log(error)
    proxy.$swal.fire({
      icon: 'error',
      title: '',
      text: error?.response?.data?.error || 'Tente novamente mais tarde.'
    })
  }
}

const confirmSubmission = async () => {
  // Validações
  if (!form.value.title.trim()) {
    proxy.$swal.fire({ icon: 'warning', title: 'Título obrigatório' })
    return
  }
  if (!form.value.description.trim()) {
    proxy.$swal.fire({ icon: 'warning', title: 'Descrição obrigatória' })
    return
  }

  // Exibe o modal com customização de cores
  const result = await proxy.$swal.fire({
    title: 'Confirmar Publicação',
    text: "Você tem certeza que deseja publicar este projeto?",
    icon: 'question',
    showCancelButton: true,

    // Confirmação: Preto da aplicação, texto branco (padrão)
    confirmButtonColor: '#1a1a1a',

    // Cancelar: Define a cor do fundo do botão de cancelar como branco
    // e usa uma classe customizada para forçar o texto a ser escuro
    cancelButtonColor: '#ffffff',

    confirmButtonText: 'Sim, Publicar!',
    cancelButtonText: 'Cancelar',

    // Adiciona classe customizada ao botão de cancelar
    customClass: {
      confirmButton: 'swal2-confirm-btn-custom',
      cancelButton: 'swal2-cancel-btn-custom'
    },

  })

  // 3. Verifica o resultado
  if (result.isConfirmed) {
    await sendProject()
  }
}


const getCategories = async () => {
  try {
    const { data } = await api.get('/categories')
    categories.value = data.data || []
  } catch (error) {
    proxy.$swal.fire({ icon: 'error', title: '', text: 'Não foi possível carregar as categorias.' })
  }
}

// helper para mostrar tamanho dos arquivos
const formatBytes = (bytes, decimals = 1) => {
  if (!bytes) return '0 B'
  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
}
</script>

<style scoped>
/* ajuste mínimo, estético */
</style>
<style>
/* Estiliza o botão de Cancelar para ter texto escuro e borda */
.swal2-cancel-btn-custom {
  color: #1f2937 !important;
  /* Cor do texto (Dark Gray) */
  border: 1px solid #9ca3af !important;
  /* Borda sutil (Gray 400) */
  background-color: #ffffff !important;
  /* Fundo branco */
}

/* Garante que o hover também seja visível */
.swal2-cancel-btn-custom:hover {
  background-color: #f3f4f6 !important;
  /* Levemente cinza no hover */
}

.swal2-confirm-btn-custom {
  color: #ffffff !important;
  /* ← TEXTO BRANCO */
  background-color: #1a1a1a !important;
  border: none !important;
}

.swal2-confirm-btn-custom:hover {
  background-color: #000000 !important;
}
</style>